import { ICSSInJSStyle } from "@fluentui/react-northstar";

import { useFluentColorScheme } from "../../../shared/theme/useColorScheme";
import { usePlatformTypeContext } from "../../platform-type-provider/PlatformTypeProvider";

interface ResultsDeviceStatusCardStyles {
  label: ICSSInJSStyle;
  deviceResult: ICSSInJSStyle;
  deviceIcon: ICSSInJSStyle;
  deviceResultContainer: ICSSInJSStyle;
}

export const useResultsDeviceStatusCardStyles: () => ResultsDeviceStatusCardStyles =
  () => {
    const { white } = useFluentColorScheme();
    const { isMobile } = usePlatformTypeContext();

    if (isMobile) {
      return {
        label: {
          backgroundColor: "transparent",
          color: white.foreground,
        },
        deviceResult: {
          // minHeight: "52px",
        },
        deviceIcon: {
          color: "gray",
        },
        deviceResultContainer: {
          width: "100%",
        },
      };
    } else {
      return {
        label: {
          backgroundColor: "transparent",
          color: white.foreground,
        },
        deviceResult: {
          maxHeight: "78px",
          maxWidth: "408px",
        },
        deviceIcon: {
          color: white.foreground,
          height: "20px",
          width: "20px",
        },
        deviceResultContainer: {
          minWidth: "415px",
          minHeight: "320px",
        },
      };
    }
  };
